/* beautiful-react-hooks version: 0.33.5 */
import { slicedToArray as _slicedToArray } from './_virtual/_rollupPluginBabelHelpers.js';
import { useEffect } from 'react';
import createHandlerSetter from './utils/createHandlerSetter.js';

var useDidMount = function useDidMount(handler) {
  var _createHandlerSetter = createHandlerSetter(handler),
      _createHandlerSetter2 = _slicedToArray(_createHandlerSetter, 2),
      onMountHandler = _createHandlerSetter2[0],
      setOnMountHandler = _createHandlerSetter2[1];

  useEffect(function () {
    if (onMountHandler.current) {
      onMountHandler.current();
    }
  }, []);
  return setOnMountHandler;
};

export default useDidMount;
